import { ResignationView } from '@/components/Approval/@components/Resignation';
import {
  parseResignationContent,
  parseResignationData,
} from '@/utils/approval/resignation';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 196 퇴직원 — 레거시 조회처럼 퇴사 정보·날짜 표는 data, 아래는 저장 content */
const ResignationSlot = ({ data }: ContentExtraProps) => {
  const content = parseResignationContent(data.attributes);
  const saved = parseResignationData(data.attributes);
  if (!content && !saved) return null;
  return (
    <ContentSlotRoot>
      <ResignationView content={content} data={saved} />
    </ContentSlotRoot>
  );
};

export default ResignationSlot;
